import {request} from '../../helpers/request.js';
import React from 'react'
import {t} from '../../helpers/translate'
import ModalComponent from './ModalComponent';
import ConfirmationScreenComponent from './ConfirmationScreenComponent';
let config = require('config');

class ConfirmationEmailComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      to: [this.props.defaultEmail],
      cc: this.props.ccEmail ? [this.props.ccEmail] : [],
      agentCc: (this.props.hasAgentCC && this.props.agentEmail) ? [this.props.agentEmail] : [],
      showModal: false,
      modalTitle: null,
      modalBody: null,
      modalSize: null,
      defaultCC: this.props.defaultCC ? this.getDefaultCC(this.props.defaultCC) : config.default.email.policyConfirmation.cc
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      defaultCC: nextProps.defaultCC ? this.getDefaultCC(nextProps.defaultCC) : config.default.email.policyConfirmation.cc,
    })
  }

  getDefaultCC(defaultCC){
    if( typeof defaultCC === 'string' ) {
        return [defaultCC];
    }
    return defaultCC;
  }

  handleModalClose() {
    this.setState({
      showModal: false
    });
  }

  showModal(title, body, size = null) {
    this.setState({
      showModal: true,
      modalBody: body,
      modalTitle: title,
      modalSize: size
    });
  }

  handleToChange(event) {
    this.setState({
      to: this.splitEntities(event.target.value)
    });
  }

  handleCcChange(event) {
    this.setState({
      cc: this.splitEntities(event.target.value)
    });
  }

  handleAgentCcChange(event) {
    this.setState({
      agentCc: this.splitEntities(event.target.value)
    });
  }

  splitEntities(value){
    value = value.replaceAll(' ','');
    value = value.replaceAll(',','');
    return value.split(';');
  }

  handleViewKeyPressed() {
    this.props.showLoading('Loading Preview');
    request(`${config.default.api}/${'previewconfirmation'}/${this.props.source}/${this.props.applicationId}`, 'GET', null, (data, statusCode) => {
      if (statusCode == 200) {
        this.showModal( t('Preview Confirmation'), <ConfirmationScreenComponent data={data} />, 'lg');
      } else {
        this.showModal( t('Error'), t(`Unable to generate confirmation screen (code ${statusCode}).`));
      }
      this.props.hideLoading();
    });

  }

  handleSendKeyPressed(event) {
    let hidePremiumConfig = config.default.clients[this.props.source].hidePremium;
    if (hidePremiumConfig === undefined) {
      hidePremiumConfig = false;
    }

    if (this.state.cc.length > 5) {
      this.showModal('Error', t('Please enter no more than 5 email addresses'));
      this.props.hideLoading();
    } else {
      this.props.showLoading('Sending Confirmation');
      request(`${config.default.api}/${'notification'}/${this.props.source}/email/payment_success/${this.props.applicationId}`, 'POST', {
        to: this.state.to.filter(x => x.trim()),
        cc: this.getAllCcEmails().filter(x => x.trim()),
        hidePremium: hidePremiumConfig
      }, (data, status) => {
        if (status == 200) {
          this.showModal('Success', `${t('A confirmation email has been sent to')} ${this.state.to.join(', ')}.`);
        } else if (status == 500) {
          this.showModal(t('Error'), t('Unable to send the Confirmation'));
        } else {
          this.showModal('Error', <div>{data.messages.map((message) => <p>{t(message)}</p>)}</div>);
          event.preventDefault();
        }
        this.props.hideLoading();
      }, { 'Accept-Language': this.props.locale })
    }
  }

  getAllCcEmails(){
    return [
      ...this.state.cc,
      ...this.state.agentCc,
      ...this.state.defaultCC,
    ];
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-4 form-group">
            <label className="text-uppercase">{t('To')}</label>
            <input
              className="form-control"
              value={this.state.to.join(';')}
              onChange={this.handleToChange.bind(this)}
              type="text"
            />
          </div>
          <div className="col-md-4 form-group">
            <label className="text-uppercase">{t('CC')}</label>
            <input
              className="form-control"
              value={this.state.cc.join(';')}
              onChange={this.handleCcChange.bind(this)}
              type="text"
            />
            <p>{t('Enter up to 5 email addresses, separated with a semicolon “;”')}</p>
          </div>
          {this.props.hasAgentCC ? 
            <div className="col-md-4 form-group">
              <label className="text-uppercase">{t('Agent Email')}</label>
              <input
                className="form-control"
                value={this.state.agentCc.join(';')}
                onChange={this.handleAgentCcChange.bind(this)}
                type="text"
              />
            </div> 
            : null
          }
        </div>
        {this.props.hideAutomaticCC ? null :
          <div className="row">
            <div className="col-md-4 form-group">
              <label className="text-uppercase">{t('Automatic CC')}</label>
              <input
                className="form-control"
                value={this.state.defaultCC.join(';')}
                type="text"
                disabled
              />
            </div>
          </div>
        }
        <div className="row">
          <div className="col-md-12">
            <div className="btn-group pull-left">
              <button className="btn button-primary" onClick={this.handleViewKeyPressed.bind(this)}>
                {t('Preview Confirmation')}
              </button>
              <button className="btn button-secondary" onClick={this.handleSendKeyPressed.bind(this)}>
                {t('Send Confirmation')}
              </button>
            </div>
          </div>
        </div>
        <br />
        <ModalComponent
          title={this.state.modalTitle}
          body={this.state.modalBody}
          onClose={this.handleModalClose.bind(this)}
          show={this.state.showModal}
          size={this.state.modalSize}
        />
      </div>
    );
  }
}

ConfirmationEmailComponent.displayName = 'ConfirmationEmailComponent';
export default ConfirmationEmailComponent;



// WEBPACK FOOTER //
// ./src/components/common/ConfirmationEmailComponent.js